module.exports = __webpack_public_path__ + "img/collect.69772a6a.svg";